import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import ROUTES from '@CONSTANTS/ROUTES.constant';

import { useDeleteSection } from '@SERVICES';
import useDeleteSectionModal from '@HOOKS/store/modals/useDeleteSectionModal';

import DeleteItemModal from '@MODALS/common/DeleteItemModal';

function DeleteSectionModal() {
    const navigate = useNavigate();
    
    const {
        state: { data: modalParams },
        actions,
    } = useDeleteSectionModal();

    const [
        deleteSection,
        {
            isLoading, isSuccess, isError, error,
        },
    ] = useDeleteSection();

    // Navigate to chapter page after successful deletion
    useEffect(() => {
        if (isSuccess) {
            navigate(ROUTES.admin.chapters.id.get(modalParams!.chapterId));
        }
    }, [isSuccess, navigate, modalParams]);

    return (
        <DeleteItemModal
            modalTitle="Delete section"
            name={modalParams!.name}
            itemName="Section"
            description="All variants of this section will also be deleted!"
            isLoading={isLoading}
            isSuccess={isSuccess}
            isError={isError}
            error={error}
            onDelete={() => {
                deleteSection({
                    id: modalParams!.id,
                    documentId: modalParams!.documentId,
                    chapterId: modalParams!.chapterId,
                });
                actions.confirm();
            }}
            onClose={() => {
                actions.close();
            }}
        />
    );
}

export default DeleteSectionModal;
